import React from 'react';

interface Props {
  loading: boolean;
  brandName: string;
  description: string;
  onChange: (p: { brandName?: string; description?: string }) => void;
  onSave: () => void;
}

const AddBrandModal: React.FC<Props> = ({ loading, brandName, description, onChange, onSave }) => (
  <div className="modal fade" id="add_brand" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add Item Brand</h5>
          <button className="btn-close custom-btn-close border p-1 me-0 text-dark" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="col-form-label">Brand Name <span className="text-danger">*</span></label>
            <input type="text" className="form-control" value={brandName}
              onChange={(e) => onChange({ brandName: e.target.value })} />
          </div>
          <div className="mb-0">
            <label className="col-form-label">Description <span className="text-danger">*</span></label>
            <input type="text" className="form-control" value={description}
              onChange={(e) => onChange({ description: e.target.value })} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary me-2" data-bs-dismiss="modal">Cancel</button>
          <button className="btn btn-success" data-bs-dismiss="modal" onClick={onSave} disabled={loading}>
            {loading ? <span className="spinner-border spinner-border-sm me-2" role="status" /> : 'Save'}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AddBrandModal;
